export const SAPPHIC_GENDERS = ["cis_woman", "trans_woman"] as const;

/**
 * Returns true if the user's quiz answers indicate they belong to the sapphic
 * community. Explicit `community` field takes precedence; gender identity is
 * used as a fallback when `community` is absent.
 */
export function isSapphicUser(qa: {
  community?: string | null;
  genderIdentity?: string[] | null;
}): boolean {
  return (qa.genderIdentity ?? []).some((g) =>
    (SAPPHIC_GENDERS as readonly string[]).includes(g),
  );
}

export type ClubAudience = "sapphic" | "gay";

/**
 * Which club audience a user belongs to. Unlike `isSapphicUser`, the explicit
 * quiz `community` answer wins; "mixed" or missing falls back to gender.
 */
export function resolveClubAudience(qa: {
  community?: string | null;
  genderIdentity?: string[] | null;
}): ClubAudience {
  if (qa.community === "sapphic") return "sapphic";
  if (qa.community === "men") return "gay";
  return isSapphicUser(qa) ? "sapphic" : "gay";
}
